import { useParams } from "react-router-dom";
import AddComponent from "../AddComponent";
import SaveButton from "../SaveButton";
import Filter from "../Filter";
import VisualizeEditButton from "../VisualizeEditButton";
import ExitButton from "../ExitButton";
import TooltipConfig from "../../../components/Tooltip";

const SubHeader = () => {
  const { mode } = useParams();
  const newPage = window.location.href.split("/")[6];
  return mode === "edit" ? (
    <div className="display-flex pb-3 row">
      <div className="col-12 col-md-4 text-md-start text-center pb-3 pb-md-0">
        <div className="d-flex justify-content-md-start justify-content-center align-items-center">
          <AddComponent />
          <Filter />
        </div>
      </div>
      <div className="col-6 col-md-4 text-center">
        <VisualizeEditButton />
      </div>
      <div className="col-6 col-md-4 text-md-end text-center">
        <SaveButton />
        {newPage ? (
          <TooltipConfig
            content={["Sair sem salvar nova página"]}
            children={<ExitButton />}
            style={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  ) : (
    <div className="display-flex-center pb-3">
      <VisualizeEditButton />
    </div>
  );
};

export default SubHeader;
